module.exports = __webpack_public_path__ + "media/images/credit_cards_32-78828550f6563914d127d6fc91b8672d.png";